module.exports = __webpack_public_path__ + "static/media/The Terrace Alcoves 7.e650ba2a.jpg";